import request from '@/utils/request'

export const getOrderList = () =>
  request({
    url: `/orders/`,
    method: 'get'
  })
export const getOrderSummary = (id: string) =>
  request({
    url: `/order/summary/${id}`,
    method: 'get'
  })
export const getOrderSummaryTimeline = (id: string) =>
  request({
    url: `/order/summary/timeline/${id}`,
    method: 'get'
  })
export const postOrderComment = (id: string, comment: string) =>
  request({
    url: `/order/summary/${id}`,
    data: { comment: comment },
    method: 'post'
  })
export const confirmOrderShipped = (id: string, sendMail: boolean, trackingCode: string | null) =>
  request({
    url: `/order/${id}/shipping/confirm`,
    data: { sendMail: sendMail, trackingCode: trackingCode },
    method: 'post'
  })
